import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';

import uploadImg from "../../Assets/Images/Careers/folder1.png"
import bin from "../../Assets/Images/Careers/delete.png"
import SuccessModal from "../../Componants/Models/SuccessModal";
const JobDetail = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: '',
  });
  const [file, setFile] = useState(null);

  const [errors, setErrors] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: '',
    resume: ''
  });

  const [uploadState, setUploadState] = useState("idle");
  // idle | uploading | done

  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    isError: false
  });

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/jobs/${id}`)
      .then((res) => {
        if (res.data.success) {
          setJob(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch job:", err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email) && (email.endsWith('.com') || email.endsWith('.org') ||
      email.endsWith('.net') || email.endsWith('.edu') || email.endsWith('.in'));
  };

  const validateMobile = (mobile) => {
    const re = /^\d{10}$/;
    return re.test(mobile);
  };

  const validateFile = (file) => {
    if (!file) return false;

    const validTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp"
    ];

    return validTypes.includes(file.type) && file.size <= 5 * 1024 * 1024;
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      fullName: '',
      mobileNumber: '',
      emailAddress: '',
      message: '',
      resume: ''
    };

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
      valid = false;
    } else if (!/^[A-Za-z\s]+$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Full Name should only contain letters and spaces";
      valid = false;
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = "Full Name must be at least 2 characters long";
      valid = false;
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile Number is required';
      valid = false;
    } else if (!validateMobile(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
      valid = false;
    }

    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = 'Email is required';
      valid = false;
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Please enter a valid email address (e.g. example@gmail.com)';
      valid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Please tell us about yourself';
      valid = false;
    }

    if (!file) {
      newErrors.resume = 'Resume is required';
      valid = false;
    } else if (!validateFile(file)) {
      newErrors.resume = 'Please upload PDF, Word, or Image file (max 5MB)';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));

    if (errors[id]) {
      setErrors(prev => ({ ...prev, [id]: '' }));
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!validateFile(selectedFile)) {
      setErrors(prev => ({
        ...prev,
        resume: "Please upload PDF, Word, or Image file (max 5MB)"
      }));
      return;
    }

    setErrors(prev => ({ ...prev, resume: "" }));
    setFile(selectedFile);

    // Start Upload UI
    setUploadState("uploading");
    setUploadProgress(0);
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);

      if (progress >= 100) {
        clearInterval(interval);
        setUploadState("done");
      }
    }, 200);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const data = new FormData();
    data.append("fullName", formData.fullName);
    data.append("mobileNumber", formData.mobileNumber);
    data.append("emailAddress", formData.emailAddress);
    data.append("message", formData.message);
    data.append("position", job.position);
    data.append("resume", file);

    try {
      await axios.post(`${API_BASE_URL}/api/getintouch`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      setModalData({
        title: "Your Application Has Been Received!",
        message: "Your details have been successfully received. We appreciate your interest and will contact you shortly.",
        isError: false
      });


      setShowModal(true);

      // Reset Form
      setFormData({
        fullName: "",
        mobileNumber: "",
        emailAddress: "",
        message: ""
      });

      setFile(null);
      setUploadState("idle");
      setUploadProgress(0);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

    } catch (err) {
      console.error(err);

      // ❌ Show Error Modal
      setModalData({
        title: "Error",
        message: err.response?.data?.message || "Failed to submit the form. Please try again.",
        isError: true
      });

      setShowModal(true);
    }
  };

  if (loading) {
    return <p className="text-center py-10">Loading job details...</p>;
  }

  if (!job) {
    return <p className="text-center py-10">Job not found.</p>;
  }

  return (
    <div className="font-sans antialiased text-gray-800 bg-gray-100 min-h-screen py-12 mt60">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12 border border-gray-200">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Left Column */}
            <div className="lg:col-span-2">
              <div className="mb-8 pb-4 border-b border-gray-200">
                <h1 className="text-3xl md:text-4xl font-bold text-[#FFA500] mb-2">
                  Position: {job.position}
                </h1>
                <div className="flex flex-wrap items-center text-gray-600 text-sm md:text-base space-x-4">
                  <span>📍 {job.workMode}</span>
                  <span>💼 {job.workType}</span>
                  <span>⏳ Experience: {job.experience}</span>
                </div>
              </div>

              <div className="mb-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4">JOB OVERVIEW</h2>
                <p>{job.overview}</p>
              </div>

              {job.responsibilities?.length > 0 && (
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">RESPONSIBILITIES</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.responsibilities.map((resp, i) => (
                      <li key={i}>{resp}</li>
                    ))}
                  </ul>
                </div>
              )}

              {job.qualification?.length > 0 && (
                <div className="mb-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">QUALIFICATION</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.qualification.map((qual, i) => (
                      <li key={i}>{qual}</li>
                    ))}
                  </ul>
                </div>
              )}

              {job.skills?.length > 0 && (
                <div>
                  <h2 className="text-xl md:text-2xl font-bold mb-4">SKILLS</h2>
                  <ul className="list-disc list-inside space-y-2">
                    {job.skills.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Right Column - Application Form */}
            <div className="lg:col-span-1 bg-gray-50 p-6 rounded-lg shadow-inner border border-gray-200 h-fit">
              <h2 className="text-xl md:text-2xl font-bold mb-6 text-center">Apply For This Job</h2>

              <form onSubmit={handleSubmit} className="form-wrapper">

                {/* Full Name */}
                <div className="floating-group">
                  <input
                    type="text"
                    id="fullName"
                    name='fullName'
                    placeholder=" "
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                  <label htmlFor="fullName">Full Name *</label>
                  {errors.fullName && <p className="form-error">{errors.fullName}</p>}
                </div>

                {/* Mobile */}
                <div className="floating-group">
                  <input
                    type="tel"
                    id="mobileNumber"
                    placeholder=" "
                    value={formData.mobileNumber}
                    onChange={handleChange}
                  />
                  <label htmlFor="mobileNumber">Mobile Number *</label>
                  {errors.mobileNumber && <p className="form-error">{errors.mobileNumber}</p>}
                </div>

                {/* Email */}
                <div className="floating-group">
                  <input
                    type="text"
                    id="emailAddress"
                    placeholder=" "
                    value={formData.emailAddress}
                    onChange={handleChange}
                  />
                  <label htmlFor="emailAddress">Email Address *</label>
                  {errors.emailAddress && <p className="form-error">{errors.emailAddress}</p>}
                </div>

                {/* Message */}
                <div className="floating-group">
                  <textarea
                    id="message"
                    rows="4"
                    placeholder=" "
                    value={formData.message}
                    onChange={handleChange}
                  />
                  <label htmlFor="message">Tell us about yourself *</label>
                  {errors.message && <p className="form-error">{errors.message}</p>}
                </div>

                <div className="modern-upload-wrapper">

                  {uploadState === "idle" && (
                    <label htmlFor="resume" className="upload-box">
                      <input
                        ref={fileInputRef}
                        type="file"
                        id="resume"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                        onChange={handleFileChange}

                      />
                      <div className="upload-content">
                        <div className="upload-icon">
                          <img src={uploadImg} className='uploadfile' />
                        </div>
                        <h4  >Drop file here</h4>
                        <p>Support for single upload. PDF, DOC, DOCX, JPG, PNG (Max 5MB)</p>
                      </div>
                    </label>
                  )}

                  {uploadState === "uploading" && (
                    <div className="upload-box uploading">
                      <div className="progress-circle">
                        <div
                          className="circle"
                          style={{ "--progress": uploadProgress }}
                        >
                          <span>{uploadProgress}%</span>
                        </div>

                      </div>
                      <p>Uploading files...</p>
                    </div>
                  )}

                  {uploadState === "done" && file && (
                    <div className="uploaded-file-card">
                      <div className="file-info">
                        <div className="file-icon">📄</div>
                        <div>
                          <h5>{file.name}</h5>
                          <p>{(file.size / 1024).toFixed(2)} KB</p>
                        </div>
                      </div>

                      <div className="file-actions">
                        <span className="success-check">✔</span>
                        <div>
                          <img className='binimg' src={bin}
                            onClick={() => {
                              setFile(null);
                              setUploadState("idle");
                              setUploadProgress(0);

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}

                          />
                        </div>

                      </div>
                    </div>
                  )}

                  {errors.resume && <p className="form-error">{errors.resume}</p>}
                </div>
                {/* Submit Button */}
                <button type="submit" className="submit-btn">
                  Send Message →
                </button>

              </form>

            </div>
          </div>
          <SuccessModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            title={modalData.title}
            message={modalData.message}
            isError={modalData.isError}
          />
        </div>
      </div>
    </div>
  );
};

export default JobDetail;